<template>
  <header 
    v-if="shouldShowHeader"
    class="py-12 px-xl-12 fixed-top app-header-inter-pages page-container">
    <NuxtLayout name="header" />
  </header>
  <slot />
  <NuxtLayout name="footer">
    <NuxtLayout name="marks-footer"></NuxtLayout>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { breakpoints } from "~/utils/breakpoints";

const route = useRoute();
const { renderWidth } = useDeviceWidth();

const shouldShowHeader = computed(() => {
  const hideOnMobile = route.meta.hideHeaderOnMobile;
  const isMobile = renderWidth.value < breakpoints.screen_laptop;
  return !(hideOnMobile && isMobile);
});
</script>

<style scoped>

</style>
